module.exports = __webpack_public_path__ + "public/SideMenuIcons/manageUser.svg?38a625dd";